import {
  TrackOlciFlowEventInterface,
  TrackOlciFlowParamsInterface,
  GlobalAnalyticsVariablesInterface
} from '../interfaces';
import {analyticsConstants} from '../../constants';
import {TelemetryGenericEnum} from '../../shared/enums';
import {retrieveMergeResponseGlobalVarsCase} from './retrieve-merge-response-global-vars.case';

export const trackSaveCardPayloadCase = (
  payload: TrackOlciFlowParamsInterface,
  globalVariables?: GlobalAnalyticsVariablesInterface,
): TrackOlciFlowEventInterface => {
  const data = retrieveTrackSaveCardPayload(payload);
  return retrieveMergeResponseGlobalVarsCase(true, data, globalVariables);
}

const retrieveTrackSaveCardPayload = (
  payload: TrackOlciFlowParamsInterface,
): TrackOlciFlowEventInterface => ({
  eventType: TelemetryGenericEnum.INTERACTION_EVENT_TYPE,
  olciPassengerIds: payload.olciPassengerIds ?? TelemetryGenericEnum.EMPTY_VALUE,
  fluidVariable: analyticsConstants.FLOW_EVENTS.SAVE_CARD_FLUID_VARIABLE,
  interaction: analyticsConstants.FLOW_EVENTS.SAVE_CARD_INTERACTION,
  pageName: analyticsConstants.FLOW_EVENTS.SAVE_CARD_PAGE_NAME,
})
